import { render } from "./CIS-FAQ-Item.vue?vue&type=template&id=50a6b496&scoped=true"
import script from "./CIS-FAQ-Item.vue?vue&type=script&lang=js"
export * from "./CIS-FAQ-Item.vue?vue&type=script&lang=js"

import "./CIS-FAQ-Item.vue?vue&type=style&index=0&id=50a6b496&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a6b496"]])

export default __exports__